import { AccountsSDK } from "./accounts"
import { InvitationsSDK } from "./invitations"
import { UsersSDK } from "./users"

class HomeFinancialSDK {
  // @ts-expect-error
  #baseUrl: string = import.meta.env.VITE_HOME_FINANCIAL_BASE_URL
  #users: UsersSDK = new UsersSDK(this.#baseUrl, this.getAuthHeaders.bind(this))
  #accounts: AccountsSDK = new AccountsSDK(this.#baseUrl, this.getAuthHeaders.bind(this))
  #invitations: InvitationsSDK = new InvitationsSDK(this.#baseUrl, this.getAuthHeaders.bind(this))

  getAuthHeaders() {
    const token = localStorage.getItem("auth_token")
    if (!token) {
      throw new Error("Authentication token not found. Please log in again.")
    }
    return {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    }
  }

  get baseUrl() {
    return this.#baseUrl
  }

  get users() {
    return this.#users
  }

  get accounts() {
    return this.#accounts
  }

  get invitations() {
    return this.#invitations
  }
}

export default HomeFinancialSDK

export const homeFinancialSDK = new HomeFinancialSDK()
